




import ProductInfoWidget from './ProductInfoWidget.vue';
import { Prop } from 'vue-property-decorator';
import { default as Component } from 'vue-class-component';
import IocContainer from '@/container/IocContainer';
import SERVICES from '@/container/Services';
import Format from '@/interfaces/Format';
import ProductData from '@/interfaces/ProductData';
import NonCommodityProductFacade from '@/models/NonCommodityProductFacade';
import ThgServiceElliDefault from '@/models/thg/ThgServiceElliDefault';

const formatProvider = IocContainer.get<Format>(SERVICES.FORMAT);

@Component({
  filters: {
    euro: formatProvider.euro(),
    euroFull: formatProvider.euroFull()
  }
})
export default class NonCommodityProductInfoWidget extends ProductInfoWidget {
  @Prop() public extendedDataParentKey!: string;
  @Prop() public product!: ProductData;

  isDescriptionShown = false;

  public mounted(): void {
    if (this.sessionState.productCode === this.product.productCode) {
      this.store.dispatch('setNonCommodityProduct', this.product);
      this.$emit('selectProduct', this.product);
    }
  }

  public get thgConfig(): ThgServiceElliDefault {
    return ThgServiceElliDefault.instance;
  }

  public toggleDescription(): void {
    this.isDescriptionShown = !this.isDescriptionShown;
  }

  get isSelected(): boolean {
    return this.product.productCode == this.store.state.nonCommodityProductData.productCode;
  }

  public selectProduct(): void {
    this.store.dispatch('setNonCommodityProduct', this.product);
    this.$emit('selectProduct', this.product);
  }

  protected get nonCommodityProductPrice(): number | undefined {
    return this.nonCommodityProduct.getBasePrice(this.thgConfig.selectedVehicleTypeIdentifier);
  }

  public get nonCommodityProductPriceBrutto(): number | undefined {
    return this.nonCommodityProduct.getBasePriceBrutto(this.thgConfig.selectedVehicleTypeIdentifier);
  }

  public get nonCommodityProduct(): NonCommodityProductFacade {
    return NonCommodityProductFacade.withData(this.product);
  }
}
